
export class StorageLocationDto{
    sampleRequestId:number
    location:number
    quantity:number
     
     constructor(
         sampleRequestId:number,
    location:number,
    quantity:number
     ){
        this.location = location
        this.sampleRequestId = sampleRequestId
        this.quantity = quantity
       
         }
 
 
 
 }